export default __webpack_public_path__ + "static/media/stamp.54e28ebb.png";